import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { Badge, type BadgeVariant } from "~/components/ui/badge";
import { Text } from "~/components/text";
import type { MetadataEvent } from "~/pages/product-details/tabs/sales-data-tab/hooks/use-metadata-events";
import { hasAdoptedContent } from "./onix-import-tooltip-content";

export const MetadataEventClusterMarkerRow = ({
  event,
}: {
  event: MetadataEvent;
}) => {
  const { t } = useTranslation(["productDetails"]);

  const badge = useMemo((): { variant: BadgeVariant; label: string } => {
    switch (event.type) {
      case "ONIX_IMPORT":
        return {
          variant: hasAdoptedContent(event) ? "success" : "secondary",
          label: t("productDetails:salesData.events.onixImport.badge"),
        };
      case "GENERATION":
        return {
          variant: "default",
          label: t("productDetails:salesData.events.generation.badge"),
        };
      case "RELEASE_DATE":
        return {
          variant: "secondary",
          label: t("productDetails:salesData.events.releaseDate.title"),
        };
      default:
        throw new Error(`Unhandled metadata event type: ${event.type}`);
    }
  }, [event, t]);

  return (
    <li className="flex items-center justify-between gap-3">
      <Badge variant={badge.variant}>{badge.label}</Badge>
      <Text as="span" variant="muted">
        {format(event.occurredAt, "d MMM yyyy")}
      </Text>
    </li>
  );
};
